import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js';

// Styles
import { SmartContainer, Surface, StyledGridItem, Stack, StyledFormWrap } from '../../styles/Containers'
import { StyledH3, StyledB, StyledP, StyledA } from '../../styles/StyledHTML';
import { StyledButton } from '../../styles/matieralui/Button'
import { StyledSwitch } from '../../styles/matieralui/Switch'

// Redux
import { createCheckoutSession, redirectToCheckout } from '../../redux/Billing/billing.actions'
import { FullBilling } from '../../redux/Billing/billing.selectors'
import { openToast } from '../../redux/UI/ui.actions';
import { CurrentNetwork } from '../../redux/Network/network.selectors'
import { useAnalytics } from '../../modules/Analytics/AnalyticsService';
import { postMessage } from '../../services/Utils';
import { FullAccount } from '../../redux/Account/account.selectors';

// Load Stripe
export const PlanItem = ({ plan, cycle, onClick }) => {

    let amount = plan[cycle].price;
    if (cycle === 'monthly') amount = `${plan[cycle].symbol}${amount}/m`;
    return (
        <StyledGridItem width="100%" >
            <StyledFormWrap width="100%" >
                <Stack textAlign="center" padding={5}>
                    <SmartContainer><StyledH3>{amount}</StyledH3></SmartContainer>
                    <StyledP light>{plan.description}</StyledP>
                    <StyledButton variant="contained" color="pop" onClick={() => onClick(plan)}>Purchase</StyledButton>
                </Stack>
            </StyledFormWrap>
        </StyledGridItem>
    )
}

export const CycleSelector = ({ onChange, value }) => {



    const handleChange = (e) => {
        if (e.target.checked) onChange('yearly')
        else onChange('monthly')
    }

    const checked = value === 'yearly'

    return (
        <SmartContainer>
            <StyledA onClick={() => onChange('monthly')}>Monthly</StyledA>
            <StyledSwitch color="primary" checked={checked} onChange={handleChange} />
            <StyledA onClick={() => onChange('yearly')}>Yearly</StyledA>
        </SmartContainer>
    )
}


export const PlanSelector = () => {

    // const { billing } = config;
    const dispatch = useDispatch();
    const fullBilling = FullBilling();
    const fullAccount = FullAccount();
    const [cycle, setCycle] = useState('monthly');
    const [stripeLoading, setStripeLoading] = useState(false);
    const currentNetwork = CurrentNetwork();
    const { billing } = currentNetwork;
    const [attempt, setAttempt] = useState(0);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const { trackEvent } = useAnalytics();

    // Create Checkout Session
    const handleChoosePlan = (plan) => {

        // Set the Plan
        setSelectedPlan(plan);

        let args = {};
        if (billing?.coupon && attempt < 1) {
            args = {
                discounts: [{
                    coupon: billing?.coupon
                }]
            }

        }

        // Trial
        if (billing?.trial && billing?.trial != 'none') {
            args.subscription_data = {}
            args.subscription_data.trial_period_days = 7;
        }

        // Update The Attemp
        setAttempt(attempt + 1);

        const { id } = plan[cycle];


        // Track: Initial Checkout
        const trackArgs = {
            category: 'User',
            action: 'InitiateCheckout',
            facebook: {
                content_category: `Subscription`, //'Apparel & Accessories > Shoes', // TODO: Categories.
                value: plan[cycle]?.price, // TODO: Update to use billing. 
                currency: 'USD'
            }
        }

        // Track
        trackEvent('InitiateCheckout', trackArgs);

        // Fire Post Message
        postMessage('OPEN_PLAN_SELECTOR', { account: fullAccount?.account, plan: args });

        dispatch(createCheckoutSession(currentNetwork.id, id, args))

    }

    // Redirect to checkout
    const redirectToCheckout = async (sessionId) => {

        setStripeLoading(true)
        const stripePromise = loadStripe(currentNetwork.stripePublicKey);

        const stripe = await stripePromise;
        const result = await stripe.redirectToCheckout({
            sessionId: sessionId,
        });

        if (result.error) {
            dispatch(openToast(result.error.message, 'error'))
            setStripeLoading(false)
        }
    }

    // Listen For Session Changes
    useEffect(() => {

        // Redirect to Stripe Checkout
        if (fullBilling.checkoutSessionSuccess) {

            redirectToCheckout(fullBilling.checkoutSession.id)

        }

        // Display Error
        if (fullBilling.checkoutSessionError) {
            setAttempt(attempt + 1);
            dispatch(openToast(fullBilling.checkoutSessionError, 'error'))
            if (attempt == 1) {
                handleChoosePlan(selectedPlan)
            }
        }
    }, [fullBilling.checkoutSessionLoading])


    // Render Products
    const renderProducts = () => billing.plans.map(plan => (<PlanItem key={plan.name} plan={plan} cycle={cycle} onClick={handleChoosePlan} />))

    // Loading



    return (
        <Stack thinking={fullBilling.checkoutSessionLoading || stripeLoading}>
            <SmartContainer>
                <Stack textAlign="center">
                    {/* <StyledH3>Select A Plan</StyledH3> */}
                    {billing.singleBillingFrequency !== true && (<CycleSelector onChange={(value) => setCycle(value)} value={cycle} />)}
                </Stack>
            </SmartContainer>
            <SmartContainer flex>{renderProducts()}</SmartContainer>
        </Stack>

    )
}